/**
 * Common state shared across Mapping Config
 */
export abstract class MappingConfig {
    public constructor(public readonly text: string | undefined) {}
}
